<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/f0EbLN/tc-custom/9781788638975.jpg?1740291517077" alt="This image is the cover for the book Dark Palace, Detective Silas Quinn Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dark Palace, Detective Silas Quinn Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <p>  </p><p><b>A police inspector investigates a grisly murder at a movie premiere in this dark historical mystery set in pre–World War I London.</b></p><p> London, April 1914. Against his better judgement, Detective Inspector Silas Quinn is attending the premiere of the new motion picture by notorious American film-maker Konrad Waechter. </p><p> But the glamorous event is interrupted by the piercing screams of a young woman in the street outside. She has been viciously mutilated in a horrific accident which eerily echoes a macabre act of violence in Waechter’s film. </p><p> As he questions those who attended the premiere, Quinn’s jaundiced view of the fledgling film industry as a business based on pretense, where no one is what they seem, appears to be justified. But soon the investigation takes a disturbing twist that has him questioning everything he thought he knew . . . </p><p><b>An excellent choice for fans of C. J. Sansom, Rory Clements and S. G. MacLean.</b></p><p><b>Praise for <i>The Dark Palace</i> </b></p><p><b>“Stellar. . . . [Quinn’s] </b><b>most bizarre case yet. . . . Ruth Rendell fans open to stories set a century ago will be well satisfied.” —<i>Publishers Weekly</i> (starred review)</b></p><b>“A lively cast of supporting characters . . . adds Dickensian zest. Quinn’s third case . . . benefits greatly from Morris’ colorful period-flavor prose.” —<i>Kirkus Reviews</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        R. N. Morris
      </h2>
      
      <p class="authorDescription body article">R.N. Morris is the author of five Silas Quinn mysteries as well as the acclaimed St Petersburg historical crime series featuring detective Porfiry Petrovich from Dostoevsky's Crime and Punishment. He lives in West Sussex with his wife and two children.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Canelo Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?29f5a16d